import { getCarHireSelectedRateOption } from 'checkout/lib/utils/carHire/view'
import { getCarHireRentalDays } from './getCarHireRentalDays'
import { buildItemPolicyLookup } from './buildItemPolicyEvaluationItem'
import { resolveCartLineTravellers, type CartLineContext } from './resolveCartLineTravellers'
import type { CartEvaluationItemInputWire } from 'businessTraveller/api/requestPostCartEvaluation'

// Car hire: one line per car hire view
export function buildCarHireCartEvaluationItems(
  carHireItemsViews: App.WithDataStatus<Array<App.Checkout.CarHireItemView>>,
  context: CartLineContext,
): Array<CartEvaluationItemInputWire> {
  if (!carHireItemsViews.hasRequiredData) {
    return []
  }

  const items: Array<CartEvaluationItemInputWire> = []

  for (const carHireItemView of carHireItemsViews.data) {
    const item = carHireItemView.item
    const selectedRateOption = getCarHireSelectedRateOption(item)
    const cost = (selectedRateOption.payNowAmount ?? 0) + (item.selectedInsurance?.total ?? 0)
    if (!cost) {
      continue
    }

    const carHire = {
      offerId: item.offerId,
      pickUpLocationId: item.pickUpLocationId,
      dropOffLocationId: item.dropOffLocationId,
      pickUpDate: item.pickUpDate,
      dropOffDate: item.dropOffDate,
    }

    items.push({
      transactionKey: item.transactionKey,
      cost,
      travellers: resolveCartLineTravellers(context),
      itemPolicyLookup: buildItemPolicyLookup({
        itemPolicyType: 'CAR_HIRE',
        cacheKey: item.transactionKey,
        currencyCode: context.currencyCode,
        employeeIds: [],
        numberOfDays: getCarHireRentalDays(item.pickUpDate, item.dropOffDate),
        travellerCount: context.travellerCount,
      }),
      details: { carHire },
    })
  }

  return items
}
